module.exports = __webpack_public_path__ + "static/delphe-86af93b420b95073f38e9e7ee7de515d.jpg";